import React from 'react';
import { FaImage, FaTimes, FaPlus, FaTrash } from 'react-icons/fa';

const TalkForm = ({ threadPosts, addThreadPost, removeThreadPost, updateThreadPost, handleThreadMediaChange }) => (
  <div className="space-y-4">
    <label className="text-sm text-gray-600 block"><span className="font-arthaus">Talk Points</span> ({threadPosts.length}/10)</label>
    {threadPosts.map((post, index) => (
      <div key={`thread-${index}`} className="relative bg-gray-100 rounded-lg p-4 border-l-4 border-[#4A90E2]">
        <div className="flex items-start space-x-2">
          <div className="w-6 h-6 bg-[#4A90E2] text-white rounded-full flex items-center justify-center text-xs font-bold">{index + 1}</div>
          <div className="flex-1">
            <textarea
              value={post.content}
              onChange={(e) => updateThreadPost(index, 'content', e.target.value)}
              className="w-full bg-white border border-gray-200 focus:border-[#4A90E2] rounded-lg p-3 text-gray-900 placeholder:text-gray-400 transition-all outline-none min-h-[60px] resize-none"
              placeholder={index === 0 ? "Start your talk..." : "Continue your talk..."}
              data-testid={`thread-post-${index}`}
            />
            {post.mediaPreview ? (
              <div className="relative mt-2">
                <img src={post.mediaPreview} alt="Thread media" className="w-full max-h-32 object-cover rounded-lg" />
                <button
                  type="button"
                  onClick={() => { updateThreadPost(index, 'media', null); updateThreadPost(index, 'mediaPreview', null); }}
                  className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1"
                >
                  <FaTimes size={10} />
                </button>
              </div>
            ) : (
              <label className="mt-2 flex items-center space-x-2 text-gray-500 hover:text-[#4A90E2] cursor-pointer text-sm">
                <FaImage size={14} />
                <span>Add image</span>
                <input type="file" accept="image/*" onChange={(e) => handleThreadMediaChange(index, e)} className="hidden" />
              </label>
            )}
          </div>
          {threadPosts.length > 1 && (
            <button type="button" onClick={() => removeThreadPost(index)} className="text-red-500 hover:text-red-600 p-1">
              <FaTrash size={14} />
            </button>
          )}
        </div>
      </div>
    ))}
    {threadPosts.length < 10 && (
      <button type="button" onClick={addThreadPost} className="w-full py-2 border-2 border-dashed border-gray-300 rounded-lg text-gray-500 hover:text-[#4A90E2] hover:border-[#4A90E2] transition-colors flex items-center justify-center space-x-2">
        <FaPlus size={12} />
        <span>Add to talk</span>
      </button>
    )}
  </div>
);

export default TalkForm;
